import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react';
import React, { Component } from 'react';

export class EUIDialog extends Component {

    static defaultProps = {
        buttons: [],
        isOpen: false,
        maxWidth: "50vw!important",
        message: "",
        onDismiss: null,
        titre: "",
    };

    render = () => {

        const { buttons, isOpen, maxWidth, message, onDismiss, titre } = this.props;
        const dialogContentProps = {
            type: DialogType.normal,
            title: titre,
            subText: message
        };
        const modalProps = {
            isBlocking: true,
            styles: { main: { maxWidth } }
        };

        return <Dialog
            hidden={!isOpen}
            onDismiss={onDismiss}
            dialogContentProps={dialogContentProps}
            modalProps={modalProps}
        >
            {this.props.children}
            <DialogFooter>
                {buttons}
            </DialogFooter>
        </Dialog>;

    }
}